// Declare function available at runtime
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare function require(name: string): any;

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettifyXml'
})

export class PrettifyXmlPipe implements PipeTransform {

  public transform(content: string): string {
    if (content) {
      if (/^<+[^>]+>/.test(content)) {
        // Get xml-formatter (js) pretty-print function
        const format = require('xml-formatter');
        return format(content, {
          indentation: '  ',
          collapseContent: true,
          lineSeparator: '\n'
        });
      }
      return content;
    }

    return '';
  }
}
